import { nanoid } from 'nanoid'

const getSendWith = (sendOptions) => {
  if (!sendOptions) return null

  const gmailOption = sendOptions.find((option) => option.type === 'gmail')
  const outlookOption = sendOptions.find((option) => option.type === 'outlook')

  if (gmailOption && !outlookOption) {
    return { type: 'gmail', account_uuid: gmailOption.accountUuid, emailAddress: gmailOption.emailAddress }
  }

  if (outlookOption && !gmailOption) {
    return { type: 'outlook', account_uuid: outlookOption.accountUuid, emailAddress: outlookOption.emailAddress }
  }

  return null
}

export const getDefaultActionConfiguration = (type, sendOptions) => {
  switch (type) {
    case 'booking.email.event_to_publisher':
    case 'booking.sms.event_to_invitee':
      return {
        type,
        variant: 'custom',
        send_with: null
      }
    case 'booking.email.event_to_someone_else':
    case 'booking.email.event_to_invitee':
      return {
        type,
        variant: 'custom',
        send_with: getSendWith(sendOptions)
      }
    case 'booking.sms.event_to_publisher':
      return {
        type,
        phone_number_uuid: null,
        variant: 'custom'
      }
    default:
      return {}
  }
}

const sendWithForActionType = ({ configuration }, sendOptions) => {
  const { type } = { ...configuration }
  switch (type) {
    case 'booking.email.event_to_invitee':
    case 'booking.email.event_to_someone_else':
      return getSendWith(sendOptions)
    case 'booking.email.event_to_publisher':
    case 'booking.sms.event_to_invitee':
    case 'booking.sms.event_to_publisher':
    default:
      return null
  }
}

const assignSendOptionsToAction = (action, sendOptions) => ({
  key: nanoid(5),
  ...action,
  configuration: {
    ...action.configuration,
    send_with: sendWithForActionType(action, sendOptions)
  }
})

export const assignSendOptionsToTemplate = (template, sendOptions) => ({
  ...template,
  workflow_rule: {
    ...template.workflow_rule,
    workflow_actions: template.workflow_rule.workflow_actions.map((action) => (
      assignSendOptionsToAction(action, sendOptions)
    ))
  }
})
